import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';

import AboutSectionImage from '../../../assets/about/about-section-7-image.png';

import AboutTextBox from '../aboutTextBox/AboutTextBox';
import styles from './AboutOurTokenSection.module.scss';

const AboutOurTokenSection = ({ mainAnimationLoaded }: { mainAnimationLoaded: boolean }) => {
  return (
    <div className={styles['section']}>
      <div className={styles['content']}>
        <ScrollInAnimationItem delay="0.2s">
          <AboutTextBox
            dark
            className={styles['textbox']}
            caption={
              <>
                our <b>token</b>
              </>
            }
            content={
              <>
                <p>
                  The RMV is a deflationary utility token that enables the growth of the Reality NFT platform and
                  unifies all its elements. From receiving discounts on auctions and fees to offering NFT priority buys
                  to acting as a governance token for the community, the RMV token interconnects all existing features.
                  It will also enable contributors to earn royalties from Landlord GO and all upcoming games.
                </p>
              </>
            }
          />
        </ScrollInAnimationItem>
        <ScrollInAnimationItem className={styles['section-image-container']} delay="0.1s">
          <img
            alt=""
            className={styles['section-image']}
            src={mainAnimationLoaded ? AboutSectionImage : ''}
            width="409"
            height="406"
          />
        </ScrollInAnimationItem>
      </div>
    </div>
  );
};

export default AboutOurTokenSection;
